module.exports = __webpack_public_path__ + "img/turbine3.ceb58de9.png";